var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircleBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 33.6666C7.80992 33.6666 0.333313 26.19 0.333313 17C0.333313 7.80992 7.80992 0.333313 17 0.333313C26.19 0.333313 33.6666 7.80992 33.6666 17C33.6666 26.19 26.19 33.6666 17 33.6666ZM17 1.99998C8.7289 1.99998 1.99998 8.7289 1.99998 17C1.99998 25.2711 8.7289 32 17 32C25.2711 32 32 25.2711 32 17C32 8.7289 25.2711 1.99998 17 1.99998ZM17 3.66665C9.63618 3.66665 3.66665 9.63618 3.66665 17C3.66665 24.3638 9.63618 30.3333 17 30.3333C24.3638 30.3333 30.3333 24.3638 30.3333 17C30.3333 9.63618 24.3638 3.66665 17 3.66665Z",
    fill: "#007BC0"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleBlue);
export default __webpack_public_path__ + "static/media/circle-blue.a1e104984e0bc0224985bccebace3c61.svg";
export { ForwardRef as ReactComponent };